import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { SignOut, Warning } from "@phosphor-icons/react";
import Logo from "@/components/Logo";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function StaffLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  const [ctx, setCtx] = useState(null);

  useEffect(() => {
    api.get("/staff/context").then((r) => setCtx(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen ok-bg grain relative">
      <div className="max-w-md mx-auto min-h-screen flex flex-col">
        <header className="flex items-center justify-between px-5 pt-6 pb-4">
          <div className="flex items-center gap-2">
            <Logo mark className="h-6" />
            <div className="leading-tight">
              <p className="font-display font-bold text-sm">{ctx?.business?.name || "OneKite Business"}</p>
              <p className="text-[10px] text-muted-foreground">{user?.name} · {user?.role?.replace("_", " ")}</p>
            </div>
          </div>
          <button data-testid="staff-logout" onClick={() => { logout(); nav("/login"); }} className="text-muted-foreground hover:text-foreground">
            <SignOut size={20} />
          </button>
        </header>

        {ctx && ctx.business.status !== "active" && (
          <div className="mx-5 mb-3 rounded-xl bg-amber-500/10 border border-amber-500/30 p-3 flex items-center gap-2 text-xs text-amber-600">
            <Warning size={16} /> Business pending OneKite approval — loyalty transactions are disabled.
          </div>
        )}

        <main className="flex-1 px-5 pb-8">
          <Outlet context={ctx} />
        </main>
      </div>
    </div>
  );
}
